import { render } from "@testing-library/react";
import type { AppFeatures } from "common/components/SerializedApp";
import { AppKind } from "common/components/SerializedApp";
import { TailwindThemeProvider } from "sharedUI/lib/tailwind-theme-provider";
import { getRuntimeThemeForPlatform, getWireAppThemeForPlatform } from "webapp/lib/theme/theme";

export function getAppFeaturesFromPlay(): AppFeatures | undefined {
    return (window as any)?.appLogin?.features;
}

export function getAppKindFromPlay() {
    return getAppFeaturesFromPlay()?.appKind === "page" ? AppKind.Page : AppKind.App;
}

export function getTheme() {
    const isPage = getAppKindFromPlay() === AppKind.Page;

    const platformTheme = isPage
        ? getWireAppThemeForPlatform(
              {
                  primaryAccentColor: "#EC6337",
                  showTabLabels: true,
                  themeOverlay: "none",
                  themeIsAdaptive: false,
                  increaseContrast: false,
                  showDesktopSideBar: false,
              },
              "iOS"
          )
        : getRuntimeThemeForPlatform(
              {
                  primaryAccentColor: "pink",
                  showTabLabels: true,
                  themeOverlay: "none",
                  themeIsAdaptive: false,
                  increaseContrast: false,
                  showDesktopSideBar: false,
              },
              "iOS"
          );
    return platformTheme;
}

export function renderWithTheme(ui: React.ReactElement) {
    return render(<TailwindThemeProvider theme={getTheme()}>{ui}</TailwindThemeProvider>);
}
